import {
  faFish,
  faCity,
  faUsers,
  faMusic,
  faHandshake,
  faPaintBrush,
  faLandmark,
  faChalkboardTeacher,
  faTheaterMasks,
  faLeaf,
  faPeopleRoof,
  faStar,
  faUtensils,
  faPuzzlePiece,
  faGift,
  faBook,
  faQuestion,
  faTree,
  faBasketballBall,
  faMicrochip,
  faSuitcaseRolling,
  faSpa,
  faPerson,
  faUserNurse,
  faChildren,
  faPersonCane,
  faChild,
} from "@fortawesome/free-solid-svg-icons";

export const categoryIconMap = {
  Adults: faPerson,
  Aquarium: faFish,
  Caregivers: faUserNurse,
  City: faCity,
  Community: faUsers,
  Concerts: faMusic,
  Conventions: faHandshake,
  Crafts: faPaintBrush,
  Culture: faLandmark,
  Education: faChalkboardTeacher,
  Entertainment: faTheaterMasks,
  Environment: faLeaf,
  Family: faPeopleRoof,
  Festivals: faStar,
  Food: faUtensils,
  Hobbies: faPuzzlePiece,
  Holidays: faGift,
  Kids: faChildren,
  Library: faBook,
  Other: faQuestion,
  Outdoors: faTree,
  Parks: faTree,
  "Parks & Recreation": faTree, // Alias for Parks
  Seniors: faPersonCane,
  Sports: faBasketballBall,
  Technology: faMicrochip,
  Teens: faChild,
  Tourism: faSuitcaseRolling,
  Wellness: faSpa,
};

export const monthMap = {
  Jan: "January",
  Feb: "February",
  Mar: "March",
  Apr: "April",
  May: "May",
  Jun: "June",
  Jul: "July",
  Aug: "August",
  Sep: "September",
  Oct: "October",
  Nov: "November",
  Dec: "December",
};

export const errorMessages = {
  textTooShort: "Please type at least 3 characters.",
  textTooLong: "Please keep your text within 100 characters.",
  invalidCharacters: "Invalid characters detected. Please use only allowed characters.",
};

export const customMapStyle = [
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.business",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.attraction",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi.medical",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }],
  },
];
